(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-devices', {
            parent: 'entity',
            url: '/tab-devices?page&sort&search',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices.html',
                    controller: 'TabDevicesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: {
                    value: '',
                    squash: true
                },
                itemsPerPageChosen: null,
                predicates : {},
                deviceType: {
                    value: '-1'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        deviceType: $stateParams.deviceType
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-devices-detail', {
            parent: 'tab-devices',
            url: '/tab-devices/{id}',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-detail.html',
                    controller: 'TabDevicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevices', function($stateParams, TabDevices) {
                    return TabDevices.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices-new', {
            parent: 'tab-devices',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-dialog.html',
                    controller: 'TabDevicesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceName: null,
                        deviceDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('tab-devices-edit', {
            parent: 'tab-devices',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.tabDevices.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-devices/tab-devices-dialog.html',
                    controller: 'TabDevicesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabDevices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabDevices', function($stateParams, TabDevices) {
                    return TabDevices.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-devices.delete', {
            parent: 'tab-devices',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-devices/tab-devices-delete-dialog.html',
                    controller: 'TabDevicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabDevices', function(TabDevices) {
                            return TabDevices.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-devices', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
